(function () {
  "use strict";

  if (customElements.get("swiper-slider")) return;
  if (!window.EssenceBaseComponent) return;

  /** Desktop breakpoint fixo — igual ao antigo theme.slider.init (768px). */
  var SLIDE_BP_DESKTOP = 768;

  function parseBoolean(value, fallback) {
    if (value === "true") return true;
    if (value === "false") return false;
    return fallback;
  }

  function parseNumber(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  /** Atributos opcionais lidos via dataset: [datasetKey, optionKey, parser, fallback]. */
  var OPTIONAL_ATTRS = [
    ["speed", "speed", parseNumber, 300],
    ["centeredSlides", "centeredSlides", parseBoolean, false],
    ["allowTouchMove", "allowTouchMove", parseBoolean, true],
    ["preventClicks", "preventClicks", parseBoolean, true],
    ["preventClicksPropagation", "preventClicksPropagation", parseBoolean, true],
  ];

  /**
   * Monta breakpoints do Swiper: só existem estes dois — viewport < 768 vs ≥ 768
   * (SLIDE_BP_DESKTOP). No Swiper, as chaves são largura mínima em px: aplica-se o bloco
   * `0` em qualquer ecrã; o bloco `768` sobrepõe a partir de 768px (desktop).
   *
   * Cada bloco define slidesPerView + spaceBetween para essa faixa. Por defeito o mesmo
   * espaço (`data-space-between`) vale para as duas; opcionalmente `data-space-between-mobile`
   * / `data-space-between-desktop` (ex.: feed Instagram: 12 e 20).
   */
  function buildBreakpointsFromSlideDataset(el) {
    var ds = el.dataset;
    if (ds.slideMobile === undefined && ds.slideDesktop === undefined) return null;

    var fallbackBetween = parseNumber(ds.spaceBetween, 10);
    var spaceBetweenAt0 =
      ds.spaceBetweenMobile !== undefined
        ? parseNumber(ds.spaceBetweenMobile, fallbackBetween)
        : fallbackBetween;
    var spaceBetweenAt768 =
      ds.spaceBetweenDesktop !== undefined
        ? parseNumber(ds.spaceBetweenDesktop, fallbackBetween)
        : fallbackBetween;

    var sm = parseFloat(ds.slideMobile);
    if (!Number.isFinite(sm)) sm = 1;
    var sd = parseFloat(ds.slideDesktop);
    if (!Number.isFinite(sd)) sd = sm;

    var out = {};
    out[0] = { slidesPerView: sm, spaceBetween: spaceBetweenAt0 };
    out[SLIDE_BP_DESKTOP] = { slidesPerView: sd, spaceBetween: spaceBetweenAt768 };
    return out;
  }

  class SwiperSlider extends window.EssenceBaseComponent {
    init() {
      if (typeof Swiper === "undefined") return;
      var slidesCount = this.querySelectorAll(".swiper-slide").length;
      if (slidesCount < 1) {
        if (!this.__tdWaitSlides) {
          var self = this;
          this.__tdWaitSlides = new MutationObserver(function () {
            if (self.querySelectorAll(".swiper-slide").length < 1) return;
            self.__tdWaitSlides.disconnect();
            self.__tdWaitSlides = null;
            self.destroy?.();
            self.__tdInitialized = false;
            self.initOnce();
          });
          this.__tdWaitSlides.observe(this, { childList: true, subtree: true });
        }
        return;
      }

      var autoplay = parseBoolean(this.dataset.autoplay, false);
      var autoplaySpeed = parseNumber(this.dataset.autoplaySpeed, 8);
      var autoplayObj = false;
      if (autoplay) {
        autoplayObj = { delay: autoplaySpeed * 1000 };
        if (this.dataset.autoplayDisableOnInteraction === "false") {
          autoplayObj.disableOnInteraction = false;
        } else if (this.dataset.autoplayDisableOnInteraction === "true") {
          autoplayObj.disableOnInteraction = true;
        }
        if (parseBoolean(this.dataset.autoplayPauseOnMouseEnter, false)) {
          autoplayObj.pauseOnMouseEnter = true;
        }
      }
      var effect = this.dataset.effect || "slide";
      var requestedLoop = parseBoolean(this.dataset.loop, true);
      var slidesPerView = parseNumber(this.dataset.slidesPerView, 1);
      var minimumSlidesForLoop = Math.ceil(slidesPerView) + 1;
      var canLoop = requestedLoop && slidesCount >= minimumSlidesForLoop;

      var paginationEl = this.querySelector(".swiper-pagination");
      var navRoot = this;
      if (this.dataset.navigationScope) {
        var scoped = this.closest(this.dataset.navigationScope);
        if (scoped) navRoot = scoped;
      }
      var nextEl =
        navRoot.querySelector(".swiper-button-next") ||
        this.querySelector(".swiper-button-next") ||
        this.querySelector(".swiper-nav-next");
      var prevEl =
        navRoot.querySelector(".swiper-button-prev") ||
        this.querySelector(".swiper-button-prev") ||
        this.querySelector(".swiper-nav-prev");
      var scrollbarEl = this.querySelector(".swiper-scrollbar");

      var slideBp = buildBreakpointsFromSlideDataset(this);

      var options = {
        spaceBetween: parseNumber(this.dataset.spaceBetween, 10),
        slidesPerView: slidesPerView,
        slidesPerGroup: 1,
        loop: canLoop,
        grabCursor: parseBoolean(this.dataset.grabCursor, true),
        effect: effect,
        autoplay: autoplayObj,
        pagination:
          parseBoolean(this.dataset.pagination, !!paginationEl) && paginationEl
            ? { el: paginationEl, clickable: true }
            : false,
        navigation:
          parseBoolean(this.dataset.navigation, !!(nextEl && prevEl)) && nextEl && prevEl
            ? { nextEl: nextEl, prevEl: prevEl }
            : false,
        scrollbar:
          parseBoolean(this.dataset.scrollbar, !!scrollbarEl) && scrollbarEl
            ? { el: scrollbarEl }
            : false,
      };

      if (slideBp) options.breakpoints = slideBp;

      OPTIONAL_ATTRS.forEach(function (entry) {
        var dsKey = entry[0];
        var optKey = entry[1];
        var parser = entry[2];
        var fallback = entry[3];
        if (this.dataset[dsKey] === undefined) return;
        options[optKey] = parser(this.dataset[dsKey], fallback);
      }, this);

      if (!this.classList.contains("swiper")) this.classList.add("swiper");
      this.swiperInstance = new Swiper(this, options);

      if (parseBoolean(this.dataset.applyThemeAnimation, false)) {
        var applyAnim = function () {
          if (theme && theme.utilities && theme.utilities.applyAnimation) {
            theme.utilities.applyAnimation();
          }
        };
        this.swiperInstance.on("afterInit", applyAnim);
        this.swiperInstance.on("loopFix", applyAnim);
      }

      if (parseBoolean(this.dataset.stopAutoplayOnInteraction, false)) {
        this.swiperInstance.on("slideChange", function (swiper) {
          if (swiper.autoplay && (swiper.touches.diff || swiper.clicked)) {
            swiper.autoplay.stop();
          }
        });
      }
    }

    onEditorBlockSelect(event) {
      if (!this.swiperInstance || !event.detail || !event.detail.blockId) return;

      var blockId = event.detail.blockId;
      var originals = this.querySelectorAll(
        ".swiper-slide:not(.swiper-slide-duplicate)"
      );
      var slideIndex = -1;
      for (var i = 0; i < originals.length; i++) {
        var slide = originals[i];
        if (
          slide.id === "Slide-" + blockId ||
          slide.getAttribute("data-block-id") === blockId
        ) {
          slideIndex = i;
          break;
        }
      }
      if (slideIndex < 0) return;

      if (this.swiperInstance.autoplay && this.swiperInstance.autoplay.running) {
        this.swiperInstance.autoplay.stop();
      }

      if (this.swiperInstance.params.loop && typeof this.swiperInstance.slideToLoop === "function") {
        this.swiperInstance.slideToLoop(slideIndex, 500);
      } else {
        this.swiperInstance.slideTo(slideIndex, 500);
      }
    }

    onEditorBlockDeselect() {
      if (!this.swiperInstance || !this.swiperInstance.autoplay) return;
      if (parseBoolean(this.dataset.autoplay, false)) {
        this.swiperInstance.autoplay.start();
      }
    }

    destroy() {
      if (this.__tdWaitSlides) {
        this.__tdWaitSlides.disconnect();
        this.__tdWaitSlides = null;
      }
      if (this.swiperInstance && typeof this.swiperInstance.destroy === "function") {
        this.swiperInstance.destroy(true, true);
      }
      this.swiperInstance = null;
    }
  }

  customElements.define("swiper-slider", SwiperSlider);
})();
